import {AxiosProcessor} from "@/shared/axios/AxiosProcessor";
const urlReport = '/report';

const state = {
    reportTable: {},
    report: {},
    reportsLastEvaluatedKey: null,
    reportsPageKey: null
};

const getters = {
    getReportTable: state => {
        return state.reportTable;
    },

    getReport: state => {
        return state.report;
    },

    getReportsLastEvaluatedKey: state => {
        return state.reportsLastEvaluatedKey;
    },
    getReportsPageKey: state => {
        return state.reportsPageKey;
    },
};

const mutations = {
    setReportTable: (state, data) => {
        state.reportTable = data;
    },

    setReport: (state, data) => {
        state.report = data;
    },

    setReportsLastEvaluatedKey: (state, data) => {
        state.reportsLastEvaluatedKey = data;
    },
    setReportsPageKey: (state, data) => {
        state.reportsPageKey = data;
    }
};

const actions = {
    async getReportTable({commit}, data) {
        let value = {};

        let response = await AxiosProcessor.list(urlReport,data);

        if(response.Items)
            value = response.Items;

        if(response.LastEvaluatedKey)
            commit('setReportsLastEvaluatedKey', response.LastEvaluatedKey);
        else
            commit('setReportsLastEvaluatedKey', null);

        commit('setReportTable', value);
    },

    async setReport ({commit}, data){
        let value = {};

        if(data.id) {
            value = await AxiosProcessor.put(urlReport+'/'+ data.id, data);
        }
        else {
            value = await AxiosProcessor.post(urlReport, data);
        }

        commit('setReport', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}